import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SpsDecidirComponent } from './components/sps-decidir.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    SpsDecidirComponent
  ],
  exports: [
    SpsDecidirComponent
  ]
})
export class SpsDecidirModule { }
